import JobLogTable from './Components/JobLogTable';
import JobTable from './Components/JobTable';
import React,{useEffect}  from 'react';
import { connect } from 'react-redux';
import { jobsActions } from '../../behavior/jobs';

const JobManagementPage = ({ getAllJobs, axiosConfig, keycloakConfig }) => {
	useEffect(()=>{
		getAllJobs(axiosConfig, keycloakConfig)
	},[])

  return (
    <div style={{ height: '100%' }}>
      <JobTable axiosConfig={axiosConfig} keycloakConfig={keycloakConfig}/>
      <JobLogTable axiosConfig={axiosConfig}/>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
	getAllJobs: (axiosConfig, keycloakConfig) => dispatch(jobsActions.getAllJobs(axiosConfig, keycloakConfig))
});

export default connect(null, mapDispatchToProps) (JobManagementPage);
